










import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  props: {
    name: String,
    value: [String, Number, Boolean, Date],
    readonly: Boolean
  }
})
